import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.KycPage.Help', {
    whatsRequired: "What's required",
    verification: 'Verification',
    originalDocument: 'Original document — not a copy, photo or screenshot',
    camera: 'A camera for the ID verification or a selfie photo of the person with the specified original document',
});
